import { FilterRenderData } from "../types";

export const compareFilterData = (
  filter1: FilterRenderData,
  filter2: FilterRenderData,
) => {
  if (filter1.targetFilter !== filter2.targetFilter) return false;
  if (
    !filter1.activeFilter?.column?.length &&
    !filter2.activeFilter?.column?.length
  )
    return true;
  return (
    filter1.activeFilter?.column === filter2.activeFilter?.column &&
    filter1.activeFilter?.label === filter2.activeFilter?.label &&
    filter1.activeFilter?.isPrimary === filter2.activeFilter?.isPrimary
  );
};
